import { toast } from "sonner";
import { photoUrl } from "@/lib/api";

const extFor = (type) => (type.includes("png") ? "png" : type.includes("webp") ? "webp" : "jpg");

async function fetchFiles(photos, baseName) {
  return Promise.all(photos.map(async (p, i) => {
    const res = await fetch(photoUrl(p.id, null, p.rotated_at));
    if (!res.ok) throw new Error("Couldn't load a photo");
    const blob = await res.blob();
    const type = blob.type || "image/jpeg";
    return new File([blob], `${baseName}-${i + 1}.${extFor(type)}`, { type });
  }));
}

function download(files) {
  files.forEach((f, i) => setTimeout(() => {
    const url = URL.createObjectURL(f);
    const a = Object.assign(document.createElement("a"), { href: url, download: f.name });
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 4000);
  }, i * 250));
}

async function shareOrDownload(files) {
  if (navigator.canShare?.({ files })) {
    await navigator.share({ files });
    return;
  }
  download(files);
  toast.success(`Downloaded ${files.length} photo${files.length === 1 ? "" : "s"}`);
}

// Share sheet ("Save Image") on iPhone, download elsewhere. If iOS drops the tap
// while photos load, offer a second tap with the files already in memory.
export async function savePhotosToDevice(photos, title = "snaplist") {
  if (!photos?.length) return;
  const baseName = (title || "snaplist").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 40) || "snaplist";
  let files;
  try {
    files = await fetchFiles(photos, baseName);
  } catch (e) {
    toast.error(e.message || "Couldn't load photos");
    return;
  }
  try {
    await shareOrDownload(files);
  } catch (e) {
    if (e?.name === "AbortError") return;
    toast(`${files.length} photo${files.length === 1 ? "" : "s"} ready`, {
      duration: 15000,
      action: { label: "Save to Photos", onClick: () => shareOrDownload(files).catch(() => download(files)) },
    });
  }
}
